import { QualificationStatusDto } from '@app/data/dtos/personal-data/qualification-status.dto';

export class QualificationStatus {
  id!: string;
  name!: string;
  endDate!: boolean;
  endDateText!: string;
}

export class ModifyStudy {
  country!: string;
  qualification!: string;
  startYear!: number;
  endYear?: number;
  status!: QualificationStatusDto;
  academy!: string;
}
